import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ONBOARDING_TOTAL, OnboardingDataService } from '../../../services/onboarding-data.service';
import { CardDirective } from '../../directives/card.directive';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

/** The way back from a step page opened with `from=start`: the count read when /start opened, the next step and a link to the list. The shell decides when it shows. */
@Component({
  selector: 'app-getting-started-return',
  standalone: true,
  imports: [RouterLink, TranslocoDirective, CardDirective, ProgressBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section *transloco="let t" appCard="info" class="flex flex-col gap-2" [attr.aria-label]="t('start.return.title')">
      <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <p class="font-semibold">{{ t('start.return.title') }}</p>
        <a routerLink="/start" class="tap-target font-semibold underline">{{ t('start.return.back') }}</a>
      </div>
      <app-progress-bar [value]="onboarding.doneOfTotal()" [max]="total" [label]="t('start.progressLabel')" />
      <p class="text-caption">
        {{ t('start.progress', { done: onboarding.doneOfTotal(), total }) }}
        @if (onboarding.nextStep(); as next) {
          · {{ t('start.return.next', { step: t('start.steps.' + next + '.title') }) }}
        }
      </p>
    </section>
  `,
})
export class GettingStartedReturnComponent {
  protected readonly onboarding = inject(OnboardingDataService);
  protected readonly total = ONBOARDING_TOTAL;
}
